import { render } from "./YoutubeEmbed.vue?vue&type=template&id=450042e6"
import script from "./YoutubeEmbed.vue?vue&type=script&lang=js"
export * from "./YoutubeEmbed.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/content/YoutubeEmbed.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "450042e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('450042e6', __exports__)) {
    api.reload('450042e6', __exports__)
  }
  
  module.hot.accept("./YoutubeEmbed.vue?vue&type=template&id=450042e6", () => {
    api.rerender('450042e6', render)
  })

}


export default __exports__